/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Frame_RateInputs */

const en_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame Rate`)
};

const fr_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence d'images`)
};

const de_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildrate`)
};

const it_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza dei fotogrammi`)
};

const ru_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частота кадров`)
};

const es_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de fotogramas`)
};

const zh_cn2_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧率`)
};

const ja_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレームレート`)
};

const hi_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेम रेट`)
};

const pt_pt2_options_general_frame_rate = /** @type {(inputs: Options_General_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de quadros`)
};

/**
* | output |
* | --- |
* | "Frame Rate" |
*
* @param {Options_General_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_frame_rate = /** @type {((inputs?: Options_General_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_frame_rate(inputs)
	if (locale === "de") return de_options_general_frame_rate(inputs)
	if (locale === "it") return it_options_general_frame_rate(inputs)
	if (locale === "ru") return ru_options_general_frame_rate(inputs)
	if (locale === "es") return es_options_general_frame_rate(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_frame_rate(inputs)
	if (locale === "ja") return ja_options_general_frame_rate(inputs)
	if (locale === "hi") return hi_options_general_frame_rate(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_frame_rate(inputs)
	return en_options_general_frame_rate(inputs)
});